// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"233":"tasktiger","367":"god","973":"graphiql"}[chunkId] || chunkId) + "." + {"8":"8f81bb","233":"f66475","367":"c89de2","785":"d59ebe","973":"fcaa14"}[chunkId] + ".js";
};